import { Form, Formik } from 'formik'
import classes from './Checkout.module.scss'
import { useEffect, useState } from 'react'
import { addAddressValidation } from '../../../validations/ProfileValidations'
import { Input } from '../../../components/Inputs/Input'
import { useLocation, useNavigate } from 'react-router-dom'
import { UserService } from '../../../services/UserService'
import { useLoader } from '../../../customHooks/loader'
import { globalErrorHandler } from '../../../utils/errorHandler'
import { sumBy } from 'lodash-es'
import GreenTick from '../../../assets/icons/GreenTick.svg';
import { CheckoutService } from '../../../services/CheckoutService'
import { toast } from 'react-toastify'
import { useCart } from '../../../customHooks/cart'
import ScrollToTop from '../../../utils/scrollToTop'

const VISIBLE_STATES = {
    EMPTY: "empty",
    ORDER_CONFIRMED: "orderConfirmed",
    CHECKOUT: "checkout"
}

export const Checkout = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const loader = useLoader();
    const cart = useCart();
    const data = location.state;
    const [initialValues, setInitialValues] = useState({});
    const [orderId, setOrderId] = useState("");
    const [visibleState, setVisibleState] = useState(VISIBLE_STATES.CHECKOUT)
    const [showShippingAddresses, setShowShippingAddresses] = useState(false);
    const [savedAddresses, setSavedAddresses] = useState([]);
    const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
    const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
    const [cartProducts, setCartProducts] = useState(data);
    const { refreshCart } = cart();

    useEffect(() => {
        getSavedAddresses();
    }, []);

    const getSavedAddresses = () => {
        UserService.getUserDetails(
            handleFetchUserDetails,
            globalErrorHandler,
            loader
        );
    }

    const handleFetchUserDetails = ({ data }) => {
        setSavedAddresses(data.data.userData.addresses);
    }

    const handleAddUserAddress = (values, resetForm) => {
        console.log({ values })
    }

    const handleCreateOrder = () => {
        if (showShippingAddresses && selectedBillingAddress === selectedShippingAddress) {
            toast.error("You have selected for different billing and shipping address but selected the same address for both")
            return;
        }
        const payload = {
            selectedBillingAddress,
            ...(showShippingAddresses ? { selectedShippingAddress } : { selectedShippingAddress: selectedBillingAddress }),
            cartProducts
        }
        CheckoutService.createOrder(
            payload,
            handleCreateOrderSuccess,
            globalErrorHandler,
            loader
        )
    };

    const handleCreateOrderSuccess = ({ data }) => {
        console.log(data.data);
        window.location.href = data.data.url;
        setOrderId(data.data.orderId);
        refreshCart(data.data.cartItems);
        setVisibleState(VISIBLE_STATES.ORDER_CONFIRMED);
    }

    return (
        <>
            <ScrollToTop trigger={visibleState} />
            {visibleState === VISIBLE_STATES.CHECKOUT ? (<div>
                {/* <div className={classes.NavHeader}> Home &gt; My Account &gt; Check Out</div> */}
                <div className={classes.CheckoutContainer}>
                    <div className={classes.BillingDataContainer}>
                        <div className={classes.heroHeader}>Billing Details</div>
                        {!savedAddresses.length ? <div className={classes.BillingAddressContainer}>

                            <Formik
                                initialValues={initialValues}
                                enableReinitialize
                                validationSchema={addAddressValidation}
                                onSubmit={(val, { resetForm }) => handleAddUserAddress(val, resetForm)}
                            >
                                {({ errors, touched, values, isValidating, handleSubmit, ...props }) => (
                                    <Form>
                                        <div className={classes.InputRow}>
                                            <Input
                                                type={'text'}
                                                name='firstName'
                                                placeholder='First Name'
                                                label='First Name'
                                                required
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                            <Input
                                                type={'text'}
                                                name='lastName'
                                                placeholder='Last Name'
                                                label='Last Name'
                                                required
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                        </div>
                                        <div className={classes.InputRow}>
                                            <Input
                                                type={'text'}
                                                name='country'
                                                placeholder='Country / Region'
                                                label='Country / Region'
                                                required
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                            <Input
                                                type={'text'}
                                                name='companyName'
                                                placeholder='Company Name'
                                                label='Company Name'
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                        </div>
                                        <div className={classes.InputRow}>
                                            <Input
                                                type={'text'}
                                                name='streetAddress'
                                                placeholder='House number and street name'
                                                label='Street Address'
                                                required
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                            <Input
                                                type={'text'}
                                                name='lastName'
                                                placeholder='apartment, suite, unit, etc. (optional)'
                                                label='Apt, suite, unit'
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                        </div>
                                        <div className={classes.InputRow}>
                                            <Input
                                                type={'text'}
                                                name='city'
                                                placeholder='Town / City'
                                                label='City'
                                                required
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                            <Input
                                                type={'text'}
                                                name='state'
                                                placeholder='State'
                                                label='State'
                                                required
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                        </div>
                                        <div className={classes.InputRow}>
                                            <Input
                                                type={'text'}
                                                name='postalCode'
                                                placeholder='Postal Code'
                                                label='Postal Code'
                                                required
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                            <Input
                                                type={'text'}
                                                name='phone'
                                                placeholder='Phone'
                                                label='Phone'
                                                required
                                                className={classes.AddressInput}
                                                labelClassName={classes.InputLabel}
                                            />
                                        </div>

                                        <button type='submit' className={classes.AddAddressSubmitButton}>
                                            Continue to delivery
                                        </button>
                                    </Form>
                                )}
                            </Formik>
                        </div> :
                            <div className={classes.AddressListContainer}>
                                {savedAddresses.map(address => {
                                    return (
                                        <div className={classes.Address}>
                                            <input type="radio" value={address.id} className={classes.radioButton} checked={selectedBillingAddress === address.id} onChange={(e) => setSelectedBillingAddress(parseInt(e.target.value))} />
                                            <div className={classes.AddressDetails}>
                                                <div className={classes.SectionTitle}>{address.firstName + " " + address.lastName + " - " + address.addressType}</div>
                                                <div className={classes.SectionSubTitle}>{address.fullAddress}</div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        <div className={classes.Section}>
                            <div className={classes.SectionTitle}>Shipping Address</div>
                            <div className={classes.SectionSubTitle}>
                                <div className={classes.AddressListContainer}>
                                    <div className={classes.Address}>
                                        <input type="radio" className={classes.radioButton} checked={!showShippingAddresses} onChange={(e) => setShowShippingAddresses(false)} />
                                        <div className={classes.AddressDetails}>
                                            <div className={classes.SectionTitle}>Same as Billing address</div>
                                        </div>
                                    </div>
                                    <div className={classes.Address}>
                                        <input type="radio" className={classes.radioButton} checked={showShippingAddresses} onChange={(e) => setShowShippingAddresses(true)} />
                                        <div className={classes.AddressDetails}>
                                            <div className={classes.SectionTitle}>Use a different shipping address</div>
                                        </div>
                                    </div>
                                </div>
                                {showShippingAddresses ? (
                                    !savedAddresses.filter(address => address.id !== selectedBillingAddress).length ?
                                        <div className={classes.BillingAddressContainer}>

                                            <Formik
                                                initialValues={initialValues}
                                                enableReinitialize
                                                validationSchema={addAddressValidation}
                                                onSubmit={(val, { resetForm }) => handleAddUserAddress(val, resetForm)}
                                            >
                                                {({ errors, touched, values, isValidating, handleSubmit, ...props }) => (
                                                    <Form>
                                                        <div className={classes.InputRow}>
                                                            <Input
                                                                type={'text'}
                                                                name='firstName'
                                                                placeholder='First Name'
                                                                label='First Name'
                                                                required
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                            <Input
                                                                type={'text'}
                                                                name='lastName'
                                                                placeholder='Last Name'
                                                                label='Last Name'
                                                                required
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                        </div>
                                                        <div className={classes.InputRow}>
                                                            <Input
                                                                type={'text'}
                                                                name='country'
                                                                placeholder='Country / Region'
                                                                label='Country / Region'
                                                                required
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                            <Input
                                                                type={'text'}
                                                                name='companyName'
                                                                placeholder='Company Name'
                                                                label='Company Name'
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                        </div>
                                                        <div className={classes.InputRow}>
                                                            <Input
                                                                type={'text'}
                                                                name='streetAddress'
                                                                placeholder='House number and street name'
                                                                label='Street Address'
                                                                required
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                            <Input
                                                                type={'text'}
                                                                name='lastName'
                                                                placeholder='apartment, suite, unit, etc. (optional)'
                                                                label='Apt, suite, unit'
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                        </div>
                                                        <div className={classes.InputRow}>
                                                            <Input
                                                                type={'text'}
                                                                name='city'
                                                                placeholder='Town / City'
                                                                label='City'
                                                                required
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                            <Input
                                                                type={'text'}
                                                                name='state'
                                                                placeholder='State'
                                                                label='State'
                                                                required
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                        </div>
                                                        <div className={classes.InputRow}>
                                                            <Input
                                                                type={'text'}
                                                                name='postalCode'
                                                                placeholder='Postal Code'
                                                                label='Postal Code'
                                                                required
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                            <Input
                                                                type={'text'}
                                                                name='phone'
                                                                placeholder='Phone'
                                                                label='Phone'
                                                                required
                                                                className={classes.AddressInput}
                                                                labelClassName={classes.InputLabel}
                                                            />
                                                        </div>

                                                        <button type='submit' className={classes.AddAddressSubmitButton}>
                                                            Continue to delivery
                                                        </button>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div> :
                                        <div className={classes.AddressListContainer}>
                                            {savedAddresses.filter(address => address.id !== selectedBillingAddress).map(address => {
                                                return (
                                                    <div className={classes.Address}>
                                                        <input type="radio" value={address.id} className={classes.radioButton} checked={selectedShippingAddress === address.id} onChange={(e) => setSelectedShippingAddress(parseInt(e.target.value))} />
                                                        <div className={classes.AddressDetails}>
                                                            <div className={classes.SectionTitle}>{address.firstName + " " + address.lastName + " - " + address.addressType}</div>
                                                            <div className={classes.SectionSubTitle}>{address.fullAddress}</div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                ) : null
                                }
                            </div>
                        </div>
                        <div className={classes.Section}>
                            <div className={classes.SectionTitle}>Shipping Method</div>
                        </div>
                        <div className={classes.Section}>
                            <div className={classes.SectionTitle}>Payment Method</div>
                            <div className={classes.SectionSubTitle}>All transactions are secure and encrypted.</div>
                            <div className={classes.PayButton} onClick={handleCreateOrder}>Pay now</div>
                        </div>
                    </div>
                    <div className={classes.SummaryContainer}>
                        <div className={classes.SummaryContainerTitle}>Order Summary</div>
                        <div className={classes.ProductSummaryContainer}>
                            {cartProducts.map((product) => (
                                <div className={classes.ProductSummary}>
                                    <div className={classes.ProductDetailsContainer}>
                                        <img src={product.productImage} alt='product' />
                                        <div className={classes.ProductDetails}>
                                            <div>{product.productName}<span className={classes.ProductDetailsSubText}>&nbsp;x {product.quantity}</span></div>
                                            <div>Color :<span className={classes.ProductDetailsSubText}>&nbsp; {product.color}</span></div>
                                        </div>
                                    </div>
                                    <div className={classes.ProductPrice}> د.إ {product.productPrice * product.quantity}</div>
                                </div>
                            ))}
                        </div>
                        <hr className={classes.BillSummarySeparator} />
                        <div className={classes.BillSummary}>
                            <div className={classes.BillSummaryRow}>
                                <div>Subtotal<span className={classes.BillSummaryRowTitle}>&nbsp;( {sumBy(data, "quantity")} items )</span></div>
                                <div className={classes.BillSummaryRowSubText}>&nbsp; {sumBy(data, (product) => product.productPrice * product.quantity)}  د.إ </div>
                            </div>
                            <div className={classes.BillSummaryRow}>
                                <div>Savings</div>
                                <div className={classes.BillSummaryRowSubText}>&nbsp;د.إ 0</div>
                            </div>
                            <hr className={classes.BillSummarySeparator} />
                            <div className={classes.BillSummaryRow}>
                                <div>Shipping</div>
                                <div className={classes.BillSummaryRowSubText}>&nbsp;د.إ 0</div>
                            </div>
                            <hr className={classes.BillSummarySeparator} />
                            <div className={classes.BillSummaryRow}>
                                <div>Total</div>
                                <div className={classes.BillSummaryRowSubText}>&nbsp; {sumBy(data, (product) => product.productPrice * product.quantity)} د.إ </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>) : visibleState === VISIBLE_STATES.ORDER_CONFIRMED ? (
                <div className={classes["order-confirmation"]}>
                    <img src={GreenTick} className={classes["order-confirmation__icon"]} alt='order confirmed' />

                    <p className={classes["order-confirmation__text"]}>
                        Your Order with Order ID #{orderId} is Confirmed
                    </p>

                    <div className={classes["order-confirmation__actions"]}>
                        <button
                            className={`${classes["order-confirmation__button"]} ${classes["order-confirmation__button--track"]}`}
                            onClick={() => navigate('/home', { state: { activeComponent: "myOrders" } })}
                        >Track Order</button>
                        <button className={`${classes["order-confirmation__button"]} ${classes["order-confirmation__button--home"]}`} onClick={() => navigate('/home')}>Back to home</button>
                    </div>
                </div>
            ) : <></>}
        </>
    )
}